module.exports = __webpack_public_path__ + "img/under-maintenance.5a85bc96.png";